import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector, shallowEqual } from 'store'
import useAllowedAccessFor from 'customHooks/useAllowedAccessFor'
import allowedRoleListWarehouseProductDetail from 'middleware/allowedRoleOnFeature/productAndStock/warehouseProductDetail'
import { useRBACHubStockDetailPage } from './rbac'

const selector = ({ auth: { userData } }: StoreStateType) => ({
  authorities: userData?.authorities || [],
})

const useRbacStockDetail = () => {
  const location = useLocation()
  const { authorities } = useAppSelector(selector, shallowEqual)
  const locationType = useMemo(() => location.pathname.split('/')[2], [location.pathname])
  const rbacHubStockDetail = useRBACHubStockDetailPage()

  const isAllowedForBtnAddProductWarehouse = useAllowedAccessFor(
    authorities,
    allowedRoleListWarehouseProductDetail.addProduct,
  )

  const isAllowedForBtnUpdateExpiryDateWarehouse = useAllowedAccessFor(
    authorities,
    allowedRoleListWarehouseProductDetail.updateExpiryDate,
  )

  const isAllowedForBtnStockInSearchWarehouse = useAllowedAccessFor(
    authorities,
    allowedRoleListWarehouseProductDetail.viewDetailInSearching,
  )

  const allowedForUpdateFieldInRowWarehouse = useAllowedAccessFor(
    authorities,
    allowedRoleListWarehouseProductDetail.updateFieldInRow,
  )
  const allowedForEditPopupUpdateLostToAvailableWarehouse = useAllowedAccessFor(
    authorities,
    allowedRoleListWarehouseProductDetail.updateLostToAvailable,
  )

  if (locationType === 'warehouse')
    return {
      isAllowedForBtnAddProduct: isAllowedForBtnAddProductWarehouse,
      isAllowedForBtnUpdateExpiryDate: isAllowedForBtnUpdateExpiryDateWarehouse,
      isAllowedForBtnStockInSearch: isAllowedForBtnStockInSearchWarehouse,
      isAllowedForBtnPrintQR: allowedForUpdateFieldInRowWarehouse,
      isAllowedForBtnUpdateProduct: allowedForUpdateFieldInRowWarehouse,
      isAllowedForUpdateQtyInRow: allowedForUpdateFieldInRowWarehouse,
      isAllowedForUpdateSlocInRow: allowedForUpdateFieldInRowWarehouse,
      isAllowedForUpdateStatusInRow: allowedForUpdateFieldInRowWarehouse,
      isAllowedForUpdateLostToAvailableInRow: allowedForEditPopupUpdateLostToAvailableWarehouse,
    }
  return rbacHubStockDetail
}
export default useRbacStockDetail
